import React, { FunctionComponent } from 'react';
import { FormControl, FormHelperText, Grid, NativeSelect } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

type FieldOfertaProps = {
    error: boolean;
    onChange: (object: any) => void;
    value: number;
    formHelperText: string;
};

function cmp(prev: FieldOfertaProps, cur: FieldOfertaProps): boolean {
    return prev.error === cur.error && prev.formHelperText === cur.formHelperText && prev.value === cur.value;
}

const FieldOferta: FunctionComponent<FieldOfertaProps> = React.memo(({ error, onChange, value, formHelperText }) => {
    const [t] = useTranslation();
    return <Grid item xs={12} sm={3}>
        <FormControl error={error} fullWidth size="small">
            <NativeSelect onChange={onChange} value={value}>
                <option value={0}>{t('ru.halls.selectors.oferta0')}</option>
                <option value={1}>{t('ru.halls.selectors.oferta1')}</option>
                <option value={2}>{t('ru.halls.selectors.oferta2')}</option>
                <option value={3}>{t('ru.halls.selectors.oferta3')}</option>
                <option value={4}>{t('ru.halls.selectors.oferta4')}</option>
                <option value={5}>{t('ru.halls.selectors.oferta5')}</option>
            </NativeSelect>
            <FormHelperText> {formHelperText} </FormHelperText>
        </FormControl>
    </Grid>;
}, cmp);

export default FieldOferta;